'use client';

import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from '@/components/ui/sidebar';
import Logo from './logo';
import Link from 'next/link';
import { NavUser } from '@/components/nav-user';
import { Home, Settings } from 'lucide-react';
import { usePathname } from 'next/navigation';
import { Session } from 'next-auth';

interface AppSidebarProps {
  session: Session | null;
}

export function AppSidebar({ session }: AppSidebarProps) {
  const pathname = usePathname();
  const isHomeActive =
    pathname === '/projects' ||
    pathname === '/' ||
    pathname.startsWith('/project') ||
    pathname.startsWith('/meeting');
  const isSettingsActive = pathname === '/settings';

  return (
    <Sidebar collapsible="icon">
      <SidebarHeader>
        <Link href="/">
          <Logo showSvgText={false}></Logo>
        </Link>
      </SidebarHeader>
      <SidebarContent>
        <SidebarGroup>
          <SidebarMenu>
            <SidebarMenuItem>
              <SidebarMenuButton
                asChild
                tooltip="Home"
                isActive={isHomeActive}
                className={
                  isHomeActive
                    ? 'bg-blue-600 text-white hover:bg-blue-700 hover:text-white [&>*]:text-white'
                    : ''
                }
              >
                <Link
                  href="/projects"
                  className={isHomeActive ? 'text-white' : ''}
                >
                  <Home className={isHomeActive ? 'text-white' : ''} />
                  <span className={isHomeActive ? 'text-white' : ''}>Home</span>
                </Link>
              </SidebarMenuButton>
            </SidebarMenuItem>
            <SidebarMenuItem>
              <SidebarMenuButton
                asChild
                tooltip="Settings"
                isActive={isSettingsActive}
                className={
                  isSettingsActive
                    ? 'bg-blue-600 text-white hover:bg-blue-700 hover:text-white [&>*]:text-white'
                    : ''
                }
              >
                <Link
                  href="/settings"
                  className={isSettingsActive ? 'text-white' : ''}
                >
                  <Settings className={isSettingsActive ? 'text-white' : ''} />
                  <span className={isSettingsActive ? 'text-white' : ''}>
                    Settings
                  </span>
                </Link>
              </SidebarMenuButton>
            </SidebarMenuItem>
          </SidebarMenu>
        </SidebarGroup>
      </SidebarContent>
      <SidebarFooter>
        {session?.user && <NavUser user={session.user} />}
      </SidebarFooter>
    </Sidebar>
  );
}
